import React from 'react';
import { IconProps } from '.';

const SvgColoredTimer = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#F33'
        d='M9.917 2.512c-.32 0-.59-.109-.806-.326a1.091 1.091 0 0 1-.325-.805c0-.32.108-.59.325-.806.217-.217.485-.325.806-.325h4.524c.32 0 .589.108.806.325.216.217.324.486.324.806 0 .32-.108.589-.324.805a1.095 1.095 0 0 1-.806.326H9.916Zm2.262 12.44c.32 0 .589-.108.806-.325.216-.217.325-.485.325-.806V9.298c0-.32-.109-.59-.325-.807a1.097 1.097 0 0 0-.806-.324c-.32 0-.59.108-.806.324a1.095 1.095 0 0 0-.325.807v4.523c0 .32.108.59.325.806.217.217.485.325.806.325Zm0 9.048a9.788 9.788 0 0 1-3.945-.805 10.407 10.407 0 0 1-3.237-2.192 10.407 10.407 0 0 1-2.192-3.237A9.788 9.788 0 0 1 2 13.821c0-1.394.268-2.71.805-3.944A10.407 10.407 0 0 1 4.997 6.64a10.39 10.39 0 0 1 3.237-2.19 9.776 9.776 0 0 1 3.945-.807c1.168 0 2.29.188 3.364.565 1.075.377 2.083.924 3.026 1.64l.82-.82c.207-.207.461-.31.763-.31.301 0 .565.112.791.339.208.207.311.47.311.791 0 .32-.103.585-.31.792l-.792.792c.716.942 1.263 1.95 1.64 3.025a10.09 10.09 0 0 1 .565 3.364c0 1.395-.268 2.71-.805 3.945a10.408 10.408 0 0 1-2.192 3.237 10.407 10.407 0 0 1-3.237 2.192A9.788 9.788 0 0 1 12.18 24Z'
      />
    </svg>
  );
};

export default SvgColoredTimer;
